import store from "@/store";
import {
  VuexModule,
  Module,
  getModule,
  Mutation,
  Action,
  MutationAction,
} from "vuex-module-decorators";

import { InvoicesService } from "@/services/api/invoices.service";
import { Invoice, InvoicesDto } from "~/invoices.type";

import i18n from "@/plugins/i18n";

@Module({ dynamic: true, store, name: "invoices", namespaced: true })
export class InvoicesVuexModule extends VuexModule {
  loading: boolean = true;
  invoicesList: [] = [];
  statuses: [] = [];
  statusFilter: number = 0;
  invoices: Invoice[] = [];

  @Mutation setInvoicesLoading(loading: boolean) {
    this.loading = loading;
  }

  @MutationAction
  public async getInvoiceStatuses() {
    const statuses = await InvoicesService.getInvoiceStatuses();
    return { statuses };
  }

  @MutationAction
  public async getInvoices(options: InvoicesDto) {
    const invoices = await InvoicesService.getInvoices(options);
    const loading = false;
    return { invoices, loading };
  }

  @Action
  public async getInvoiceDetails(invoiceRid: string) {
    const invoice = await InvoicesService.getInvoiceDetails(invoiceRid);
    return invoice;
  }
}

export const InvoicesModule = getModule(InvoicesVuexModule);
